export const QUICK_FILTER_PRESETS = [
  {
    id: 'tiny_models',
    label: 'Tiny',
    shortDescription: 'Up to 10M parameters',
    description: 'Lightweight models suitable for edge devices and quick experiments.',
    filters: {
      paramsRange: [0, 10],
      selectedBooleanFilters: []
    }
  },
  {
    id: 'small_models',
    label: 'Small',
    shortDescription: '10-50M parameters',
    description: 'Compact models balancing performance and efficiency.',
    filters: {
      paramsRange: [10, 50],
      selectedBooleanFilters: []
    }
  },
  {
    id: 'medium_models',
    label: 'Medium',
    shortDescription: '50-200M parameters',
    description: 'Mid-range models with good capacity for complex EEG tasks.',
    filters: {
      paramsRange: [50, 200],
      selectedBooleanFilters: []
    }
  },
  {
    id: 'large_models',
    label: 'Large',
    shortDescription: '200M+ parameters',
    description: 'Large-scale models offering the best performance but requiring more resources.',
    filters: {
      paramsRange: [200, 501],
      selectedBooleanFilters: []
    }
  }
];
